module.exports = __webpack_public_path__ + "static/media/social-discord.a19ee551.svg";